import { Component, inject, signal } from '@angular/core';
import { Sidebar } from './sidebar/sidebar/sidebar';
import { RouterOutlet } from '@angular/router';
import { CartDrawer } from '../../features/pedido/components/cart-drawer/cart-drawer';
import { CartStateService } from '../../features/pedido/state/cart.state';
import { PermisosService } from '../auth/permisos.service';

@Component({
  selector: 'app-layout',
  imports: [Sidebar, RouterOutlet, CartDrawer],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
})
export class Layout {
  cartState = inject(CartStateService);
  permisos  = inject(PermisosService);
  cartOpen = signal(false);
  sidebarOpen = signal(false);

  totalItems = this.cartState.totalItems;

  toggleCart() {
    this.cartOpen.update((v) => !v);
  }

  closeCart() {
    this.cartOpen.set(false);
  }

  toggleSidebar() {
    this.sidebarOpen.update((v) => !v);
  }

  closeSidebar() {
    this.sidebarOpen.set(false);
  }
}
